module.exports = __webpack_public_path__ + "36.1b88969ced00d458c1c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding/andy_jeska/36.jpg
// module id = ./src/assets/images/wedding/andy_jeska/36.jpg
// module chunks = main